export const categories = [
  'Art',
  'Business',
  'Culture',
  'Design',
  'Education',
  'Engineering',
  'Entrepreneurship',
  'Environment',
  'Essays',
  'Fiction',
  'Film',
  'Finance',
  'Fitness',
  'Food',
  'Gaming',
  'Health',
  'History',
  'Humor',
  'Leadership',
  'Life',
  'Marketing',
  'Mathematics',
  'Music',
  'Other',
  'Parenting',
  'Philosophy',
  'Poetry',
  'Politics',
  'Relationships',
  'Science',
  'Self',
  'Self-Improvement',
  'Society',
  'Spirituality',
  'Sports',
  'Technology',
  'Travel'
];
